import api from './api';

export const registerUser = async (userData) => {
  try {
    const response = await api.post('/users', userData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao registrar usuário.');
  }
};

export const getUsers = async () => {
  try {
    const response = await api.get('/users');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao carregar usuários.');
  }
};

export const toggleUserStatus = async (userId, isActive) => {
  try {
    const response = await api.put(`/users/${userId}`, { is_active: isActive });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao atualizar status do usuário.');
  }
};

export const resetTransactions = async () => {
  try {
    const response = await api.post('/settings/reset-transactions');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao resetar transações.');
  }
};

export const resetMasterData = async () => {
  try {
    const response = await api.post('/settings/reset-master-data');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao resetar dados mestres.');
  }
};

export const clearByType = async (password, companyId, type) => {
  try {
    const response = await api.post('/settings/clear-by-type', { password, company_id: companyId, type });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao excluir os dados.');
  }
};

export const resetBankBalances = async (password, companyId, mode) => {
  try {
    const response = await api.post('/settings/reset-bank-balances', { password, company_id: companyId, mode });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao resetar os saldos.');
  }
};

export const wipeAndReseed = async (password, companyId) => {
  try {
    const response = await api.post('/settings/wipe-and-reseed', { password, company_id: companyId });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao limpar os dados da empresa.');
  }
};

export const getCompanySettings = async () => {
  try {
    const response = await api.get('/settings/company');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao carregar configurações da empresa.');
  }
};

export const updateCompanySettings = async (settings) => {
  try {
    const response = await api.patch('/settings/company', settings);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Falha ao salvar configurações da empresa.');
  }
};
